import { render, staticRenderFns } from "./ResourceListContainer.vue?vue&type=template&id=47b1b3f2&scoped=true"
import script from "./ResourceListContainer.vue?vue&type=script&lang=js"
export * from "./ResourceListContainer.vue?vue&type=script&lang=js"
import style0 from "./ResourceListContainer.vue?vue&type=style&index=0&id=47b1b3f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b1b3f2",
  null
  
)

export default component.exports